/**
 * Lớp gọi API bất động sản — public (duyệt tin) và admin (CRUD, duyệt, ảnh).
 *
 * Mọi method trả về promise axios; params/filter được truyền qua query string hoặc body.
 */
import { apiClient } from '../../../shared/services/apiClient';
import { API_ROUTES } from '../../../shared/constants/apiRoutes';

export const propertyApi = {
  /** Danh sách BĐS công khai với bộ lọc tìm kiếm. */
  getProperties: (searchFilters) => apiClient.get(API_ROUTES.properties, { params: searchFilters }),
  /** Tập hợp diện tích (dùng biểu đồ/thống kê) theo filter. */
  getPropertyAreas: (searchFilters) => apiClient.get(API_ROUTES.propertyAreas, { params: searchFilters }),
  /** Chi tiết một tin theo id. */
  getProperty: (propertyId) => apiClient.get(API_ROUTES.propertyDetails(propertyId)),
  /** Gợi ý tìm kiếm theo từ khóa. */
  getSuggestions: (query) => apiClient.get(API_ROUTES.propertySuggestions, { params: { q: query } }),
  /** Tin tương tự gợi ý bên cạnh chi tiết. */
  getSimilarProperties: (propertyId) => apiClient.get(API_ROUTES.propertySimilar(propertyId)),
  /** Danh sách BĐS trong khu admin. */
  getAdminProperties: (searchFilters) =>
    apiClient.get(API_ROUTES.adminProperties, { params: searchFilters }),
  /** Chi tiết tin cho form chỉnh sửa admin. */
  getAdminProperty: (propertyId) => apiClient.get(API_ROUTES.adminPropertyDetails(propertyId)),
  /** Tạo tin mới. */
  createProperty: (propertyPayload) => apiClient.post(API_ROUTES.adminProperties, propertyPayload),
  /** Cập nhật tin đã có. */
  updateProperty: (propertyId, propertyPayload) =>
    apiClient.put(API_ROUTES.adminPropertyDetails(propertyId), propertyPayload),
  /** Duyệt/xuất bản tin (workflow admin). */
  approveProperty: (propertyId) => apiClient.post(API_ROUTES.adminPropertyApproval(propertyId)),
  /** Xóa tin. */
  deleteProperty: (propertyId) => apiClient.delete(API_ROUTES.adminPropertyDetails(propertyId)),
  /** Upload ảnh kèm tin (multipart). */
  uploadImages: (propertyId, formData) =>
    apiClient.post(API_ROUTES.adminPropertyImages(propertyId), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  /** Xóa một ảnh của tin. */
  deleteImage: (propertyId, imageId) =>
    apiClient.delete(API_ROUTES.adminPropertyImageDetails(propertyId, imageId)),
};
